<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{ tituloGrids }}</span>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col md="12" sm="12" class="pa-0 ma-0 pt-2">
        <Grid
          v-if="this.$store.state.token != ''"
          :tabla="TablaName"
          :nItemsPerPagina="10"
          :bActiveFilter="false"
          :bActiveExport="false"
          :bSingleSelect="true"
          :bShowSelect="false"
          :sIdTable="'idURLsCrontab'"
          @onBtnGenerico="onAccionEvento"
          :bShowMapDetails="false"
          :aAccionesAdicionales="aAccionesAdicionales"
          :key="nKeyGrid"
          :bActiveNew="false"
        >
        <template v-slot:slotbtnNew>
              <v-btn v-if="oPermisos.priv_insert=='1'" class="no-uppercase d-flex mx-2 my-1" small depressed dark color="primary" @click="onMostarModal(0)" rounded>
                <v-icon>mdi-plus</v-icon>
                Nuevo CronTab
              </v-btn>
            </template>
        </grid>  
      </v-col>
    </v-row>

    <FromularioCronTabs  v-model="bMostarModal" :key="nKeyFormulario" :nNuevo="nNuevoCrontab" :nIdCrontab="nIdCrontabEditar" @onActualizarGrid="onActualizarGrid"></FromularioCronTabs>
  </v-container>
</template>

<script>
import FromularioCronTabs from "@/components/Crontabs/FromularioCronTabs.vue";
import Grid from "@/components/Grid/Grid.vue";
import mxFunciones from "@/mixins/funciones.js";

export default {
  name: "ConfiguracionCrontabs",
  mixins: [mxFunciones],
  components: {
    Grid,
    FromularioCronTabs
  },
  data() {
    return {
      TablaName: "URLsCrontab", // Nombre de la tabla a trabajar
      tituloGrids: "",
      bMostarModal:false,
      nKeyFormulario:0,
      aAccionesAdicionales: [
        {
          componente: 'BtnGenerico',
          mensaje: 'Editar Crontab',
          oProps: {
            iconname:'mdi-pencil',
            sNombre:'onEditarCrontab'
          }
        },
        {
          componente: 'BtnGenerico',
          mensaje: 'Detalle Crontab',
          oProps: {
            iconname:'mdi-eye',
            sNombre:'onDetalleCrontab'
          }
        }
      ],
      nNuevoCrontab:0, /* 0 -> nuevo, 1 -> Editar, 2 -> Detalle */
      nIdCrontabEditar:"",
      nKeyGrid:0,

    };
  },
  methods:{
    onMostarModal(bNuevo=0){
      this.nKeyFormulario++;
      this.nNuevoCrontab=bNuevo;
      this.bMostarModal = true;
    },
    onAccionEvento(oItem, sAccion){
      if(sAccion === 'onEditarCrontab'){
        this.nIdCrontabEditar = oItem.idURLsCrontab;
        this.onMostarModal(1)
      }
      else if(sAccion === 'onDetalleCrontab'){
        this.nIdCrontabEditar = oItem.idURLsCrontab;
        this.onMostarModal(2)
      }
    },
    onActualizarGrid(){
      this.nKeyGrid++;
    }
  },
  async mounted() {
    this.tituloGrids = await this.getTitulo(this.TablaName);
  },
};
</script>

<style lang="scss" scoped>
</style>